export =[
    {
        "fill": {
            "gradient": {
                "type": "linear(200,0,201,0)",
                "stops": "rgba(255,0,0,.1) 0%;rgba(255,0,0,0.8) 100%"
            }
        }
    },
    {
        "fill": {
            "gradient": {
                "type": "linear(0,200,0,201)",
                "stops": "rgba(0,255,0,0.1) 0%;rgba(0,255,0,0.8) 100%"
            }
        }
    }
];